import {validApplicationTypeGuard} from './abstract-application.guard';

export const validBusinessFinanceGuard = () => {
  return validApplicationTypeGuard('BusinessLoans', 'e-not-business');
}
